/* eslint-disable */
import { MultilingualString } from '@salsita-ai/platform-common/utils'
import {
  AdminPagesSpec,
  DataSpec,
  EnumLike,
  EnumReflection,
  SchemaOfObject,
} from '@salsita-ai/platform-project-sdk/domain'

export const ApplicationVersion = '0.0.0'

export type PublishedData = {
  readonly pricing?: {
    readonly PricingConfig?: {
      readonly data: string
    }[]
  }
  readonly presetCategories?: {
    readonly id: string
    readonly name: string | MultilingualString
    readonly description?: string | MultilingualString
    readonly img?: string
    readonly imgAlt?: string | MultilingualString
    readonly presets: {
      readonly configurationId: string
      readonly revisionId: string
      readonly readToken: string
      readonly name: string | MultilingualString
      readonly description: string | MultilingualString
      readonly img?: string
      readonly imgAlt?: string | MultilingualString
      readonly detailTitle?: string
      readonly detailDescription?: string
      readonly tags?: readonly string[]
    }[]
  }[]
  readonly recipes?: {
    readonly id: string
    readonly name: string | MultilingualString
    readonly description: string | MultilingualString
    readonly collection: string
    readonly configuration: {
      readonly modelVersion: number
      readonly entities: {
        readonly id: string
        readonly type: string
        [k: string]: unknown
      }[]
      readonly rootEntityType: string
      readonly recipeIds: readonly string[]
    }
  }[]
  readonly system?: {
    readonly presetCategories?: {
      readonly id: string
      readonly name: string | MultilingualString
      readonly description?: string | MultilingualString
      readonly img?: string
      readonly imgAlt?: string | MultilingualString
      readonly presets: {
        readonly configurationId: string
        readonly revisionId: string
        readonly readToken: string
        readonly name: string | MultilingualString
        readonly description: string | MultilingualString
        readonly img?: string
        readonly imgAlt?: string | MultilingualString
        readonly detailTitle?: string
        readonly detailDescription?: string
        readonly tags?: readonly string[]
      }[]
    }[]
    readonly recipes?: {
      readonly id: string
      readonly name: string | MultilingualString
      readonly description: string | MultilingualString
      readonly collection: string
      readonly configuration: {
        readonly modelVersion: number
        readonly entities: {
          readonly id: string
          readonly type: string
          [k: string]: unknown
        }[]
        readonly rootEntityType: string
        readonly recipeIds: readonly string[]
      }
    }[]
  }
}

export const PublishedData = {
  type: 'object',
  properties: {
    pricing: {
      type: 'object',
      properties: {
        PricingConfig: {
          type: 'array',
          items: {
            type: 'object',
            properties: { data: { type: 'string' } },
            additionalProperties: false,
            required: ['data'],
          },
        },
      },
      required: [],
      additionalProperties: false,
    },
    presetCategories: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          name: {
            anyOf: [
              { type: 'string' },
              {
                import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                tsType: 'MultilingualString',
                type: 'object',
                properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                required: ['$lang'],
                additionalProperties: false,
              },
            ],
          },
          description: {
            anyOf: [
              { type: 'string' },
              {
                import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                tsType: 'MultilingualString',
                type: 'object',
                properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                required: ['$lang'],
                additionalProperties: false,
              },
            ],
          },
          img: { type: 'string' },
          imgAlt: {
            anyOf: [
              { type: 'string' },
              {
                import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                tsType: 'MultilingualString',
                type: 'object',
                properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                required: ['$lang'],
                additionalProperties: false,
              },
            ],
          },
          presets: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                configurationId: { type: 'string' },
                revisionId: { type: 'string' },
                readToken: { type: 'string' },
                name: {
                  anyOf: [
                    { type: 'string' },
                    {
                      import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                      tsType: 'MultilingualString',
                      type: 'object',
                      properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                      required: ['$lang'],
                      additionalProperties: false,
                    },
                  ],
                },
                description: {
                  anyOf: [
                    { type: 'string' },
                    {
                      import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                      tsType: 'MultilingualString',
                      type: 'object',
                      properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                      required: ['$lang'],
                      additionalProperties: false,
                    },
                  ],
                },
                img: { type: 'string' },
                imgAlt: {
                  anyOf: [
                    { type: 'string' },
                    {
                      import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                      tsType: 'MultilingualString',
                      type: 'object',
                      properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                      required: ['$lang'],
                      additionalProperties: false,
                    },
                  ],
                },
                detailTitle: { type: 'string' },
                detailDescription: { type: 'string' },
                tags: { type: 'array', items: { type: 'string' } },
              },
              required: ['configurationId', 'revisionId', 'readToken', 'name', 'description'],
              additionalProperties: false,
            },
          },
        },
        required: ['id', 'name', 'presets'],
        additionalProperties: false,
      },
    },
    recipes: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          name: {
            anyOf: [
              { type: 'string' },
              {
                import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                tsType: 'MultilingualString',
                type: 'object',
                properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                required: ['$lang'],
                additionalProperties: false,
              },
            ],
          },
          description: {
            anyOf: [
              { type: 'string' },
              {
                import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                tsType: 'MultilingualString',
                type: 'object',
                properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                required: ['$lang'],
                additionalProperties: false,
              },
            ],
          },
          collection: { type: 'string' },
          configuration: {
            type: 'object',
            properties: {
              modelVersion: { type: 'number' },
              entities: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: { id: { type: 'string' }, type: { type: 'string' } },
                  required: ['id', 'type'],
                  additionalProperties: true,
                },
              },
              rootEntityType: { type: 'string' },
              recipeIds: { type: 'array', items: { type: 'string' } },
            },
            required: ['modelVersion', 'entities', 'rootEntityType', 'recipeIds'],
            additionalProperties: false,
          },
        },
        required: ['id', 'name', 'description', 'collection', 'configuration'],
        additionalProperties: false,
      },
    },
    system: {
      type: 'object',
      properties: {
        presetCategories: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              id: { type: 'string' },
              name: {
                anyOf: [
                  { type: 'string' },
                  {
                    import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                    tsType: 'MultilingualString',
                    type: 'object',
                    properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                    required: ['$lang'],
                    additionalProperties: false,
                  },
                ],
              },
              description: {
                anyOf: [
                  { type: 'string' },
                  {
                    import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                    tsType: 'MultilingualString',
                    type: 'object',
                    properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                    required: ['$lang'],
                    additionalProperties: false,
                  },
                ],
              },
              img: { type: 'string' },
              imgAlt: {
                anyOf: [
                  { type: 'string' },
                  {
                    import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                    tsType: 'MultilingualString',
                    type: 'object',
                    properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                    required: ['$lang'],
                    additionalProperties: false,
                  },
                ],
              },
              presets: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: {
                    configurationId: { type: 'string' },
                    revisionId: { type: 'string' },
                    readToken: { type: 'string' },
                    name: {
                      anyOf: [
                        { type: 'string' },
                        {
                          import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                          tsType: 'MultilingualString',
                          type: 'object',
                          properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                          required: ['$lang'],
                          additionalProperties: false,
                        },
                      ],
                    },
                    description: {
                      anyOf: [
                        { type: 'string' },
                        {
                          import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                          tsType: 'MultilingualString',
                          type: 'object',
                          properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                          required: ['$lang'],
                          additionalProperties: false,
                        },
                      ],
                    },
                    img: { type: 'string' },
                    imgAlt: {
                      anyOf: [
                        { type: 'string' },
                        {
                          import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                          tsType: 'MultilingualString',
                          type: 'object',
                          properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                          required: ['$lang'],
                          additionalProperties: false,
                        },
                      ],
                    },
                    detailTitle: { type: 'string' },
                    detailDescription: { type: 'string' },
                    tags: { type: 'array', items: { type: 'string' } },
                  },
                  required: ['configurationId', 'revisionId', 'readToken', 'name', 'description'],
                  additionalProperties: false,
                },
              },
            },
            required: ['id', 'name', 'presets'],
            additionalProperties: false,
          },
        },
        recipes: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              id: { type: 'string' },
              name: {
                anyOf: [
                  { type: 'string' },
                  {
                    import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                    tsType: 'MultilingualString',
                    type: 'object',
                    properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                    required: ['$lang'],
                    additionalProperties: false,
                  },
                ],
              },
              description: {
                anyOf: [
                  { type: 'string' },
                  {
                    import: [{ module: '@salsita-ai/platform-common/utils', member: 'MultilingualString' }],
                    tsType: 'MultilingualString',
                    type: 'object',
                    properties: { $lang: { type: 'object', additionalProperties: { type: 'string' } } },
                    required: ['$lang'],
                    additionalProperties: false,
                  },
                ],
              },
              collection: { type: 'string' },
              configuration: {
                type: 'object',
                properties: {
                  modelVersion: { type: 'number' },
                  entities: {
                    type: 'array',
                    items: {
                      type: 'object',
                      properties: { id: { type: 'string' }, type: { type: 'string' } },
                      required: ['id', 'type'],
                      additionalProperties: true,
                    },
                  },
                  rootEntityType: { type: 'string' },
                  recipeIds: { type: 'array', items: { type: 'string' } },
                },
                required: ['modelVersion', 'entities', 'rootEntityType', 'recipeIds'],
                additionalProperties: false,
              },
            },
            required: ['id', 'name', 'description', 'collection', 'configuration'],
            additionalProperties: false,
          },
        },
      },
      required: [],
      additionalProperties: false,
    },
  },
  required: [],
  additionalProperties: false,
} as SchemaOfObject<PublishedData>

export const PublishedDataHash = 'acab1c64e135'

export type SessionData = {
  readonly id?: string
  readonly accessToken?: string
  readonly tags?: readonly string[]
  readonly emailAddress?: string
  readonly fullName?: string
}

export const SessionData = {
  type: 'object',
  properties: {
    id: { type: 'string' },
    accessToken: { type: 'string' },
    tags: { type: 'array', items: { type: 'string' } },
    emailAddress: { type: 'string' },
    fullName: { type: 'string', nullable: true },
  },
  required: [],
  additionalProperties: false,
} as SchemaOfObject<SessionData>

export type FrontendData = {
  [k: string]: unknown
}

export const FrontendData = {} as SchemaOfObject<FrontendData>

export type FinalizeData = {
  readonly addToCart: boolean
  readonly emailAddress: string
  readonly firstName: string
  readonly lastName: string
  readonly phoneNumber?: string
  readonly message?: string
  readonly submissionDate?: string
}

export const FinalizeData = {
  type: 'object',
  properties: {
    addToCart: { type: 'boolean' },
    emailAddress: { type: 'string' },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    phoneNumber: { type: 'string' },
    message: { type: 'string' },
    submissionDate: { type: 'string' },
  },
  required: ['addToCart', 'emailAddress', 'firstName', 'lastName'],
  additionalProperties: false,
} as SchemaOfObject<FinalizeData>

export type PrefetchedFinalizeData = {
  [k: string]: unknown
}

export const PrefetchedFinalizeData = {} as SchemaOfObject<PrefetchedFinalizeData>

export type FinalizeResult = {
  readonly pdfLink?: string
  readonly clientGeneratedImageLink?: string
  readonly shopifyProduct?: {
    readonly success?: boolean
    readonly productId?: number
    readonly productTitle?: string
    readonly productUrl?: string
    readonly productVariantId?: number
    readonly sku?: string
    readonly price?: string
    readonly message?: string
    readonly error?: string
  }
}

export const FinalizeResult = {
  type: 'object',
  properties: {
    pdfLink: { type: 'string' },
    clientGeneratedImageLink: { type: 'string' },
    shopifyProduct: {
      type: 'object',
      properties: {
        success: { type: 'boolean' },
        productId: { type: 'number' },
        productTitle: { type: 'string' },
        productUrl: { type: 'string' },
        productVariantId: { type: 'number' },
        sku: { type: 'string' },
        price: { type: 'string' },
        message: { type: 'string' },
        error: { type: 'string' },
      },
      additionalProperties: false,
    },
  },
  required: [],
  additionalProperties: false,
} as SchemaOfObject<FinalizeResult>

export type CallbackData = {
  readonly customProduct?: {
    readonly title: string
    readonly description: string
    readonly price: number
  }
}

export const CallbackData = {
  type: 'object',
  properties: {
    customProduct: {
      type: 'object',
      properties: { title: { type: 'string' }, description: { type: 'string' }, price: { type: 'number' } },
      required: ['title', 'description', 'price'],
      additionalProperties: false,
    },
  },
  required: [],
  additionalProperties: false,
} as SchemaOfObject<CallbackData>

export type BackendData = never

export const BackendData = undefined

export type NavigationState =
  | 'Shape'
  | 'Base'
  | 'Wood'
  | 'Appearance'
  | 'Accessories'
  | 'Summary'
  | 'FinalizeQuote'
  | 'FinalizeCart'

export const NavigationState: EnumLike<NavigationState> = new EnumReflection('NavigationState', {
  enum: ['Shape', 'Base', 'Wood', 'Appearance', 'Accessories', 'Summary', 'FinalizeQuote', 'FinalizeCart'],
}) as EnumLike<NavigationState>

export type ViewState = 'Default'

export const ViewState: EnumLike<ViewState> = new EnumReflection('ViewState', {
  enum: ['Default'],
}) as EnumLike<ViewState>

export type ToolState = 'Default'

export const ToolState: EnumLike<ToolState> = new EnumReflection('ToolState', {
  enum: ['Default'],
}) as EnumLike<ToolState>

export type ExportState = 'Default' | 'Thumbnail'

export const ExportState: EnumLike<ExportState> = new EnumReflection('ExportState', {
  enum: ['Default', 'Thumbnail'],
}) as EnumLike<ExportState>

export type AdminNavigationState = 'PresetCategories' | 'Presets' | 'Pricing'

export const AdminNavigationState: EnumLike<AdminNavigationState> = new EnumReflection('AdminNavigationState', {
  enum: ['PresetCategories', 'Presets', 'Pricing'],
}) as EnumLike<AdminNavigationState>

export type AdminViewState = 'Default'

export const AdminViewState: EnumLike<AdminViewState> = new EnumReflection('AdminViewState', {
  enum: ['Default'],
}) as EnumLike<AdminViewState>

export const $dataSpec: DataSpec = {
  custom: { PricingConfig: { definition: { data: 'string' }, chunk: 'pricing', kind: 'manual' } },
  swatchOptions: {},
}

export const $adminPagesSpec: AdminPagesSpec = {
  presets: true,
  pages: [
    {
      key: 'pricing',
      title: 'Pricing',
      icon: 'TagBold',
      navigationState: 'Pricing',
      component: 'PricingPage',
      actionsComponent: 'PricingActions',
    },
  ],
}

declare global {
  interface ApplicationTypes {
    readonly ApplicationVersion: typeof ApplicationVersion
    readonly PublishedData: PublishedData
    readonly SessionData: SessionData
    readonly FrontendData: FrontendData
    readonly FinalizeData: FinalizeData
    readonly PrefetchedFinalizeData: PrefetchedFinalizeData
    readonly FinalizeResult: FinalizeResult
    readonly CallbackData: CallbackData
    readonly BackendData: BackendData
    readonly NavigationState: NavigationState
    readonly ViewState: ViewState
    readonly ToolState: ToolState
    readonly ExportState: ExportState
    readonly AdminNavigationState: AdminNavigationState
    readonly AdminViewState: AdminViewState
  }
}
